module.exports = __webpack_public_path__ + "img/重庆巫山大昌湖国家湿地公园@2x.64c1c940.png";